import type { FC } from "react";

import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import { useTranslations } from "@jti/ui";

export type DeliveryAgeVerificationBlockProps = {
  isAgeVerified?: boolean;
  hasCompletedAgeVerification?: boolean;
  isAgeVerificationError?: boolean;
  isAgeVerificationPending?: boolean;
  onVerifyAge?: () => void;
};

export const DeliveryAgeVerificationBlock: FC<DeliveryAgeVerificationBlockProps> = ({
  isAgeVerified,
  hasCompletedAgeVerification = false,
  isAgeVerificationError = false,
  isAgeVerificationPending = false,
  onVerifyAge,
}) => {
  const { __ } = useTranslations();
  const isVerified = isAgeVerified === true;
  const shouldShowBanner = !isVerified || hasCompletedAgeVerification;

  if (!shouldShowBanner) {
    return null;
  }

  const tone = hasCompletedAgeVerification ? "success" : isAgeVerificationError ? "error" : "info";
  const description = hasCompletedAgeVerification
    ? "cart.checkout.delivery.age_verification.success"
    : isAgeVerificationError
      ? "users.profile::updating_consumer_age_verification_status_failed"
      : "cart.checkout.delivery.age_verification.pending";
  const ageVerificationAction = isVerified
    ? undefined
    : {
        label: __("cart.checkout.delivery.age_verification.cta"),
        onClick: onVerifyAge,
        disabled: !onVerifyAge || isAgeVerificationPending,
      };

  return (
    <AlertBanner
      data-testid="delivery-age-verification-block"
      description={__(description)}
      actions={ageVerificationAction ? [ageVerificationAction] : undefined}
      tone={tone}
      role="status"
    />
  );
};
